<template>
  <lu-vbox>
    <lu-hbox class="navbar">

      <!--
      <lu-vbox v-if='showLogo' class='header-logo'>
        <img src="/lusisImg/logo.png">
        < ! -- <lu-item class='sidebar-title'>{{ appTitle }}</lu-item> - - >
      </lu-vbox>
      -->

      <lu-item v-if='showLogo'  class='header-logo'  :style='titleLogoStyle' />

      <lu-vbox lu-flex class='header-container'>
        <breadcrumb class="breadcrumb-container lu-flex" />
        <tags-view />
      </lu-vbox>

      <lu-hbox lu-hcenter class="right-menu pad-in-5" style='padding-top: 10px;'>
        <template v-if="device!=='mobile'">

          <!-- <search id="header-search" class="right-menu-item" /> -->
          <!-- <error-log class="errLog-container right-menu-item"/> -->
            <lu-hbox lu-hcenter class='title' v-if='selectedEnv && userInfos'>
              {{ selectedEnv.label }} - {{ userInfos.login }}
            </lu-hbox>

            <!-- <el-popover
              placement="bottom"
              @show='alertEnabled = false'
              trigger="click">
                <message-center @closePopup='visibleMessage = false' />
                <el-badge :value='unreadMessages' :hidden='unreadMessages === 0' :max="10" type="primary" slot='reference'>
                  <lu-icon v-if='!alertEnabled' class='text-grey3 right-menu-item' lu-click >notifications_none</lu-icon>
                  <lu-icon v-else class='right-menu-item newNotification' lu-click >notifications_active</lu-icon>
                </el-badge>
            </el-popover> -->

            <el-popover
              placement="bottom"
              trigger="click">

                <lu-vbox class='vpad-in-20' style='padding: 20px;'>
                  <lu-hbox class='pad-in-20 navNotificationPanel'>
                    <lu-item lu-flex>{{ $t('navbar.notificationActive') }}</lu-item>
                    <lu-item><el-switch v-model="notificationActive" class="drawer-switch lu-flex " inactive-color="#C0CCDA" /></lu-item>
                  </lu-hbox>
                </lu-vbox>

                <el-badge :value='activeNotificationList.length' :hidden='activeNotificationList.length === 0' :max="99" type="primary" slot='reference'>
                  <lu-icon v-if='!activeNotificationList.length' class='text-grey3 right-menu-item' lu-click >notifications_none</lu-icon>
                  <lu-icon v-else class='right-menu-item newNotification' lu-click >notifications_active</lu-icon>
                </el-badge>
            </el-popover>

            <el-popover
              placement="bottom"
              trigger="click">
                <contact />
                <lu-item slot="reference" >
                  <lu-icon class='text-grey3 right-menu-item' lu-click>phone</lu-icon>
                </lu-item>
            </el-popover>

            <el-popover
              placement="bottom"
              @hide='closeProfile'
              trigger="click">

                <lu-vbox class='vpad-in-20'>
                  <lu-vbox style='padding: 20px;'>
                    <lu-hbox class='pad-in-20'>

                      <router-link to="/changePassword">
                        <lu-vbox lu-hcenter class='carteIcon'>
                          <FontIcon type='material-icons' class='right-menu-icon convert45' name='vpn_key' size='xlarge' />
                          <span>{{ $t('navbar.changePassword') }}</span>
                        </lu-vbox>
                      </router-link>

                      <router-link key='userProfile' to="getRouteProfile" @click.left.prevent.native='navigate()'>
                        <lu-vbox lu-hcenter class='carteIcon'>
                          <FontIcon type='material-icons' class='right-menu-icon' name='face' size='xlarge'/>
                          <span>{{ $t('navbar.userProfile') }}</span>
                        </lu-vbox>
                      </router-link>

                      <lu-vbox lu-hcenter class='carteIcon'>
                          <lang-select class="right-menu-icon"/>
                          <span>{{ $t('navbar.international') }}</span>
                      </lu-vbox>

                    </lu-hbox>

                    <lu-hbox class='pad-in-20'>
                      <lu-vbox lu-hcenter class='carteIcon'>
                          <screenfull class="right-menu-icon"/>
                          <span>{{ $t('navbar.screenfull') }}</span>
                      </lu-vbox>

                      <lu-vbox lu-hcenter class='carteIcon'>
                          <size-select class="right-menu-icon" />
                          <span>{{ $t('navbar.size') }}</span>
                      </lu-vbox>

                      <lu-vbox lu-hcenter class='carteIcon' :class="{isActive: expandedSettings}" @click="handleCache" >
                          <FontIcon type='material-icons' class='right-menu-icon lu-click' name='remove_circle' size='xlarge'/>
                          <span>{{ $t('navbar.removecache') }}</span>
                      </lu-vbox>

                    </lu-hbox>
                    <lu-hbox class='pad-in-20'>
                      <lu-vbox lu-hcenter class='carteIcon' :class="{isActive: expandedSettings}" v-if='showSettings' @click="handleSettings">
                          <FontIcon type='material-icons' class='right-menu-icon lu-click' name='settings' size='xlarge'/>
                          <span>{{ $t('navbar.settings') }}</span>
                      </lu-vbox>

                      <lu-vbox lu-hcenter class='carteIcon' @click="handleLogout">
                          <FontIcon type='material-icons' class='right-menu-icon negative lu-click' name='settings_power' size='xlarge'/>
                          <span>{{ $t('navbar.logout') }}</span>
                      </lu-vbox>
                    </lu-hbox>

                    <lu-vbox class='vpad-in-20 navSettginPanel' v-if='expandedSettings'>
                      <lu-item lu-fle class='head'>Settgins</lu-item>

                      <lu-hbox class='inSettgins'>
                        <lu-item lu-flex>Open History view</lu-item>
                        <lu-item><el-switch v-model="tagsView" class="drawer-switch lu-flex" /></lu-item>
                      </lu-hbox>

                      <lu-hbox class='inSettgins'>
                        <lu-item lu-flex>Logo Show</lu-item>
                        <lu-item><el-switch v-model="sidebarLogo" class="drawer-switch" /></lu-item>
                      </lu-hbox>

                      <!-- <lu-hbox class='inSettgins'>
                        <lu-item lu-flex>Theme</lu-item>
                        <el-radio-group v-model="theme">
                          <lu-vbox>
                            <el-radio v-for="item in themeList" :key="item.id" :label="item.id" class='drawer-item' style='padding-bottom: 10px !important;'>{{ item.label}}</el-radio>
                          </lu-vbox>
                        </el-radio-group>
                      </lu-hbox> -->
                    </lu-vbox>

                  </lu-vbox>

                  <lu-hbox lu-hcenter class='popupFoot' lu-click>
                    <lu-vbox lu-vcenter >Plus</lu-vbox>
                  </lu-hbox>
                  <!-- <span style="display:block;" @click="handleLogout">Log Out</span> -->

                </lu-vbox>
                <div slot='reference' class='avatar-container'>
                  <div class="avatar-wrapper">
                    <img :src="userLogo" class="user-avatar" v-if='userLogo'>
                    <lu-icon class='text-grey3 right-menu-item' lu-click v-else>account_circle</lu-icon>
                  </div>
                </div>
                <!-- <lu-icon slot="reference" class='text-grey3 head_icons icon' lu-click>perm_identity</lu-icon> -->
            </el-popover>
        </template>
      </lu-hbox>
    </lu-hbox>

  </lu-vbox>
</template>

<script>
import { LuItem, LuHbox, LuVbox, LuIcon } from 'lusis-ui'
import { mapGetters, mapState, mapActions } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import FontIcon from '@/components/FontIcon'
// import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import LangSelect from '@/components/LangSelect'
import TagsView from './TagsView'
import messageHandler from '@/mixins/message'
import variableHandler from '@/mixins/variables'
// import MessageCenter from '@/views/messages/messageCenter'
import Contact from '@/components/Contact'
import { toggleClass } from '@/utils'
import Storage from '@/utils/storage'
// import sound from '@/assets/sounds/ding.mp3'
// import logoImage from '../../../public/logo.png'

export default {
  components: { LuHbox, LuVbox, LuIcon, Breadcrumb, LuItem, Screenfull, SizeSelect, LangSelect, Contact, FontIcon, TagsView },
  mixins: [ messageHandler, variableHandler ],
  data: function () {
    return {
      alertEnabled: false,
      expandedSettings: false
      // logo: logoImage
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'selectedEnv',
      'name',
      'userLogo',
      'device',
      'userInfos',
      'unreadMessages',
      'themeList',
      'size',
      'notificationList',
      'getSoundById'
    ]),
    ...mapState({
      showSettings: state => state.settings.showSettings,
      appTitle: state => state.app.title
    }),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    fixedHeader: {
      get() {
        return this.$store.state.settings.fixedHeader
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: val
        })
      }
    },
    tagsView: {
      get() {
        return this.$store.state.settings.tagsView
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'tagsView',
          value: val
        })
      }
    },
    sidebarLogo: {
      get() {
        return this.$store.state.settings.sidebarLogo
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'sidebarLogo',
          value: val
        })
      }
    },
    theme: {
      get() {
        return this.$store.state.tangoEnv.theme
      },
      set(val) {
        let oldVal = this.$store.state.tangoEnv.theme
        toggleClass(document.body, val, oldVal)
        this.$store.dispatch('tangoEnv/setTheme', val)
      }
    },
    pageSize: {
      get() {
        return this.$store.state.app.pageSize
      },
      set(val) {
        this.$store.dispatch('app/setPageSize', val)
      }
    },
    notificationActive: {
      get() {
        return this.$store.state.user.notificationActive
      },
      set(val) {
        this.setNotificationActive(val)
      }
    },
    activeNotificationList() {
      return this.notificationList.filter(notif => notif.isRead === 0)
    }
  },
  created: function () {
    this.$tango.subscribe('newUnreadMessageCount', this, this.onNewUnreadMessageCount)
    this.$tango.subscribe('notificationUpdate', this, this.onNotificationUpdate)
  },
  beforeDestroy: function () {
    if (this.$tango) {
      this.$tango.unSubscribe('newUnreadMessageCount', this, this.onNewUnreadMessageCount)
      this.$tango.unSubscribe('notificationUpdate', this, this.onNotificationUpdate)
    }
  },
  methods: {
    ...mapActions('user', [ 'addNotification', 'setNotificationActive' ]),
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async handleLogout() {
      await this.logout()
    },
    handleCache() {
      Storage.clear()
    },
    handleSettings() {
      // this.$store.dispatch('settingsMonitor/toggleRightPanel')
      this.expandedSettings = !this.expandedSettings
    },
    changePwd() {
      this.$router.push({ path: '/changePassword' })
    },
    closeProfile() {
      this.expandedSettings = false
    },
    onNewUnreadMessageCount (message) {
      this.alertEnabled = message.unreadMessages > this.unreadMessages
      this.$store.commit('unreadMessages', message.unreadMessages)
    },
    getRouteProfile() {
      return {
        name: 'profileEdit',
        params: {
          recordId:  this.userInfos.userId,
          recordLabel:  this.userInfos.login,
          create: false,
          __isValid: 1
        }
      }
    },
    navigate() {
      let next = this.getRouteProfile()
      if ((next.path && next.path != this.$route.path) || (next.name && next.name != this.$route.name)) {
        this.$router.push(next)
      }
      else {
        this.$router.push(this.$route.path + '?next=' + new Date().toJSON()).then(() => this.$router.push(next))
      }
    },
    onNotificationUpdate(data) {
      this.addNotification(data)

      // play sound notification
      if (data.isRead === 0 && data.sound > 0) {  
        this.playSound(data.sound)
      }
    },
    playSound (sound) {
      const fileObj = this.getSoundById(sound)
      if (fileObj && fileObj.fileName) {
        var audio = new Audio(require('@/assets/sounds/' + fileObj.fileName))
        audio.play()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  background: #a11039;
//  height: 50px;
//  overflow: hidden;
//  position: relative;
//

  .breadcrumb-container {
    float: left;
  }

  .header-container {
    // display: inline-block;
    // height: 40px;
    margin-left: 10px;
  }

  .header-logo {
    margin: 5px 0;
    background: none no-repeat left;
    background-size: contain;
    height: 100px;
    width:250px;
  }

  .user-dropdown {
    padding: 20px;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    padding: 5px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      height: 100%;
      font-size: 1.8rem;
      border-radius: 50%;
      padding: 7px;

      &.hover-effect {
        cursor: pointer;
        transition: background .4s;
      }
    }

    .avatar-container {
      margin-right: 10px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }
    }

    .newNotification {
      color:#ffca28 !important;
    }

    .newNotification:hover {
      color:#fffa28 !important;
    }

    .newNotification {
      animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      transform: translate3d(0, 0, 0);
      animation-iteration-count: infinite;
      backface-visibility: hidden;
      animation-duration: 3s;
      perspective: 1000px;
      transform-origin: top center;
    }
  }
}

.title {
  font-size: 1.5em;
}

.carteIcon {
  padding: 10px;
  width: 100px;
  border: solid 1px transparent;
  border-radius: 5px;

  .right-menu-icon {
    font-size: 1.2em;
  }

}

.navSettginPanel {
  margin-top: 10px;
  border-radius: 5px;

  .head {
    margin: 10px;
  }
  .inSettgins {
    margin: 10px 30px;
  }
}

.popupFoot {
  height: 35px;
  border-radius: 0 0 10px 10px;
}
</style>
